import React from 'react';
import GuardianFacilityManagementWidget from '@amzn/GuardianFacilityManagementWidget/lib/';

const App = () => {
    return <GuardianFacilityManagementWidget />;
};

export default App;
